
const Anim = () => {

    function animate() {
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible');
                    }
                });
            },
            {threshold: 0.5}
        );

        document
            .querySelectorAll('[data-scroll-anim]')
            .forEach(item => observer.observe(item));
    }

    animate();

};

export default Anim;
